const clearCookies = (cookieNames: string[]) => {
  const domain = window.location.hostname;

  cookieNames.forEach((cookieName) => {
    document.cookie = `${cookieName}=; Max-Age=0`;
    document.cookie = `${cookieName}=; Max-Age=0; path=/; domain=${domain}`;
    document.cookie = `${cookieName}=; Max-Age=0; path=/`;
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${domain}`;
  });
};

export default clearCookies;
